import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  BoxModelIcon,
  CardStackIcon,
  Crosshair1Icon,
  Crosshair2Icon,
  FilePlusIcon,
  MixIcon,
  ReaderIcon,
  RocketIcon,
} from "@radix-ui/react-icons";
import { ReactComponent as ps5 } from "../assets/ps.svg";

// Route Props
interface RouteProps {
  title: string;
  link: string;
  logo: any;
}

export const Elgiganten_siteRoutes = ({ authRole }: { authRole: boolean }) => {
  const routes: { [key: string]: RouteProps[] } = {
    "routes.headlines.main": [
      brand.hasFeature.posts && {
        title: "routes.route.feed",
        link: siteRoutes["dashboard"],
        logo: CardStackIcon,
      },
      brand.hasFeature.zones && {
        title: "routes.route.zones",
        link: siteRoutes["zones"],
        logo: BoxModelIcon,
      },
      brand.hasFeature.news && {
        title: "routes.route.news",
        link: siteRoutes["news"],
        logo: ReaderIcon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.engagement": [
      {
        title: "Test Your Precision",
        link: siteRoutes["leet"],
        logo: MixIcon,
      },
      brand.hasFeature.challenges && {
        title: "TCL Time Trial",
        link: siteRoutes["TimeTrial"],
        logo: Crosshair2Icon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.admin": [
      brand.hasCreate.challenges &&
        authRole && {
          title: "routes.route.create.challenge",
          link: siteRoutes["createChallenge"],
          logo: MixIcon,
        },
      brand.hasCreate.news &&
        authRole && {
          title: "routes.route.create.news",
          link: siteRoutes["createNews"],
          logo: FilePlusIcon,
        },
      authRole && {
        title: "routes.route.admin.tclraffle",
        link: siteRoutes["TCLRaffle"],
        logo: FilePlusIcon,
      },
    ].filter(Boolean) as RouteProps[],
  };

  return routes;
};
